import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api, firstName, fmtDMY } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Stamp, ArrowRight } from "@phosphor-icons/react";

export default function ApprovalsBell() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/approvals/mine", { silent: true }).then((r) => alive && setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [pathname]);
  if (!d?.visible) return null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative rounded-md text-foreground hover:bg-muted" title="My approvals" data-testid="approvals-bell">
          <Stamp size={18} />
          {d.total > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-400 text-neutral-900 text-[10px] font-bold flex items-center justify-center" data-testid="approvals-count">{d.total}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="approvals-panel">
        <div className="px-3 py-2 border-b border-border flex items-center justify-between">
          <div className="font-semibold text-sm">My Approvals</div>
          <div className="flex items-center gap-2"><div className="font-mono text-[11px] text-muted-foreground">{d.total} pending</div>{d.total > 0 && <Link to="/approvals" onClick={() => setOpen(false)} className="text-[11px] text-primary hover:underline font-semibold" data-testid="approvals-open-queue">Open queue →</Link>}</div>
        </div>
        {d.total === 0 ? (
          <div className="px-3 py-8 text-center text-sm text-muted-foreground" data-testid="approvals-empty">Nothing waiting for your approval</div>
        ) : (
          <div className="max-h-[70vh] overflow-y-auto">
            {d.groups.map((g) => (
              <div key={g.key} className="border-b border-border/60 last:border-0" data-testid={`approvals-group-${g.key}`}>
                <Link to={g.to} onClick={() => setOpen(false)} className="flex items-center justify-between px-3 py-2 bg-muted/40 hover:bg-muted text-xs font-mono uppercase tracking-wider">
                  <span>{g.label} <span className="ml-1 rounded-full bg-primary/10 text-primary px-1.5 py-0.5 text-[10px]">{g.count}</span></span>
                  <ArrowRight size={12} />
                </Link>
                {g.items.slice(0, 5).map((it) => (
                  <Link key={it.id} to={g.to} onClick={() => setOpen(false)} className="flex items-center justify-between px-3 py-1.5 text-xs hover:bg-primary/5" data-testid={`approvals-item-${it.no}`}>
                    <span className="font-mono font-semibold text-primary">{it.no}</span>
                    <span className="truncate mx-2 text-muted-foreground flex-1">{it.sub || ""}</span>
                    <span className="text-[10px] text-muted-foreground whitespace-nowrap">{firstName(it.by)}{it.at ? ` · ${fmtDMY(it.at)}` : ""}</span>
                  </Link>
                ))}
                {g.count > 5 && <Link to={g.to} onClick={() => setOpen(false)} className="block px-3 py-1 text-[11px] text-primary hover:underline">+{g.count - 5} more</Link>}
              </div>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
